<template>
  <div class="d-contents">
    <div v-if="tenderCompaniesLoading" class="d-contents">
      <v-skeleton-loader type="table-row-divider" />
      <v-skeleton-loader type="table-row" />
      <v-skeleton-loader type="table-row" />
    </div>
    <CompaniesTable
      v-else-if="tenderCompanies.length"
      :show-files="false"
      :companies="tenderCompanies"
    />
    <div v-else class="tender-offers-page-plug-wrapper">
      <TenderPlug
        :title="$t('No invited companies yet')"
        :description="
          $t(
            `Invite bidders using the button below. They will receive an automatic invitation and Fixtender support will help them send the offers.`
          )
        "
        :action-text="$t('Invite company')"
        @action="editTender(tenderInfo.id, 3)"
      >
        <template #icon>
          <MessageIcon />
        </template>
      </TenderPlug>
    </div>
  </div>
</template>

<script>
  import CompaniesTable from '@/components/tenders/CompaniesTable';
  import { mapActions, mapState } from 'vuex';
  import TenderPlug from '@/components/tender/TenderPlug';
  import MessageIcon from '@/assets/icons/message-border.svg';
  import editTender from '@/utils/mixins/edit-tender';
  import { VSkeletonLoader } from 'vuetify/lib';

  export default {
    name: 'TenderCompanies',
    components: { TenderPlug, CompaniesTable, MessageIcon, VSkeletonLoader },
    mixins: [editTender],
    computed: {
      ...mapState('tender', ['tenderInfo', 'tenderCompanies', 'tenderCompaniesLoading']),
    },
    methods: {
      ...mapActions('tender', ['loadTenderCompanies']),
    },
    async created() {
      await this.loadTenderCompanies();
    },
  };
</script>
